import React from "react";
import { Row, Image, Divider, Flex, Skeleton, Button } from "antd";
import { RightOutlined, ArrowLeftOutlined } from "@ant-design/icons";

import Learningpoints from "../../../../../../../../assets/images/svgs/ic_learningpoints_programdesc.svg";
import Courses from "../../../../../../../../assets/images/svgs/ic_courses_programdesc.svg";
import ic_addcollection_contentlibrary from "../../../../../../../../assets/images/svgs/ic_addcollection_contentlibrary.svg";
import ic_removecollection_contentlibrary from "../../../../../../../../assets/images/svgs/ic_removecollection_contentlibrary.svg";

// for translate
import { useTranslation } from "react-i18next";

// import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";

// import history from "history/browser";

const ModulDetailJourneyMobileContent = ({
  loading,
  wraperStyle,
  rowImageStyle,
  thumbnail,
  divRightStyle,
  pProgramStyle,
  titleJourneyDescStyle,
  journeyName,
  rowBottomFirstStyle,
  rowBottomSecondStyle,
  pointImageWidth,
  totalPoint,
  totalCourses,
  dividerStyle,
  desc,
  overDue,
  flagBtnCollection,
  funcCollection,
  isCollection,
  setOpenModalDetailJourney,
}) => {
  const { t, i18n } = useTranslation();

  // const screens = useBreakpoint();
  // const isMobileVersion = screens.xs;

  return (
    <>
      <div style={wraperStyle}>
        <Flex style={{ display: "flex", flexDirection: "column" }}>
          <Row className="row-image" style={rowImageStyle}>
            {loading ? (
              <Skeleton.Avatar
                active
                shape="square"
                style={{ width: "165px", height: "113px", borderRadius: "8px" }}
              />
            ) : (
              thumbnail
            )}
          </Row>
          <div className="div-right" style={divRightStyle}>
            {loading ? (
              <Skeleton.Input
                active
                size={16}
                style={{ marginBottom: "10px", minWidth: "70px" }}
              />
            ) : (
              <p className="p-program" style={pProgramStyle}>
                {t("feature.feature_mylj.main_content.program")}
              </p>
            )}
            <Row>
              {loading ? (
                <Skeleton.Input
                  active
                  size={22}
                  style={{ marginRight: "8px", minWidth: "300px" }}
                />
              ) : (
                <span
                  className="title-journey-desc"
                  style={titleJourneyDescStyle}
                >
                  {journeyName}
                </span>
              )}
            </Row>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "10px",
                justifyContent: "start",
                alignItems: "center",
              }}
            >
              {overDue !== undefined ? overDue : null}

              {loading ? (
                <Skeleton.Input
                  active
                  size={20}
                  style={{ marginTop: "15px", minWidth: "250px" }}
                />
              ) : (
                <>
                  {totalCourses !== undefined && totalCourses !== null ? (
                    <Row className="row-bottom" style={rowBottomSecondStyle}>
                      <Image
                        width={pointImageWidth}
                        src={Courses}
                        preview={false}
                      />
                      {totalCourses !== undefined ? totalCourses : null}
                    </Row>
                  ) : null}
                  <Row className="row-bottom" style={rowBottomSecondStyle}>
                    <Image
                      width={pointImageWidth}
                      src={Learningpoints}
                      preview={false}
                    />
                    {totalPoint !== undefined ? totalPoint : null}
                  </Row>
                </>
              )}
            </div>
            {loading ? <Skeleton paragraph={{ rows: 10 }} active /> : desc}
          </div>
          <div
            className="btn-collection"
            style={{
              position: "absolute",
              right: 0,
              display:
                flagBtnCollection !== undefined && flagBtnCollection !== null
                  ? "block"
                  : "none",
            }}
          >
            {loading ? (
              <Skeleton.Button
                active
                style={{
                  width: "140px",
                  height: "32px",
                  borderRadius: "6px",
                }}
              />
            ) : (
              <Button
                className={
                  isCollection
                    ? "btn-remove-collection-content-library"
                    : "btn-add-collection-content-library"
                }
                name={
                  isCollection
                    ? "btn-remove-program-collection-content-library"
                    : "btn-add-program-collection-content-library"
                }
                style={{
                  borderRadius: "6px",
                  padding: "6px 12px",
                  fontSize: "12px",
                  fontWeight: "500",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "auto",
                  marginLeft: "0",
                  width: "177px",
                }}
                onClick={() => funcCollection(isCollection ? "remove" : "add")}
                loading={loading}
              >
                <div
                  style={{
                    marginTop: "-3px",
                    marginRight: "4px",
                  }}
                >
                  <Image
                    preview={false}
                    src={
                      isCollection
                        ? ic_removecollection_contentlibrary
                        : ic_addcollection_contentlibrary
                    }
                  />
                </div>
                <span style={{ lineHeight: "normal" }}>
                  {isCollection
                    ? t(
                        "feature.feature_cl.main_collection_card.remove_from_collection",
                      )
                    : t(
                        "feature.feature_cl.collection_action.add_to_collection",
                      )}
                </span>
              </Button>
            )}
          </div>
        </Flex>
      </div>
    </>
  );
};

export default ModulDetailJourneyMobileContent;
